import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  divider: {
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    background: theme.palette.grey.A100,
  },
}));

export default useStyles;
